// "use client";

import React, { useState, useEffect, useRef, useContext } from 'react';
import Tree, { TreeNode } from 'rc-tree';
import axios from 'axios';
import { DataContext } from '../../../context/DataProvider.tsx';

const T2tree = () => {
  const [tdata, setData] = useState([]);
  const treeRef = useRef();
  const {
    setTitExecutive,
    toggleSabt,

    setExecutivSectionText,
  } = useContext(DataContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          `${process.env.REACT_APP_BASE_URL}/api/data/OrgTree?exec=true`,
          {
            method: 'GET',
          },
        );
        setData(result.data);
      } catch (error) {
        console.log('errorfetchDataOrgTree', error);
      }
    };

    fetchData();

    return () => {};
  }, [toggleSabt]);

  const onSelect = (selectedKeys, info) => {
    // console.log("selected", selectedKeys);
    // console.log('infoTitExecutive.node', info.node);
    //this.selKey = info.node.props.eventKey;
    //alert(selectedKeys[0]);

    const upsertSubFun = () => {
      try {
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Organization/GetById?id=${info.node.key}`,
          {
            method: 'Get',
          },
        )
          .then((res) => {
            if (!res.ok) {
              throw new Error('کد وضعیت خطا در درخواست!' + res.status);
            }

            return res.json().then((data) => {
              console.log('data', data);
              setTitExecutive({
                ID: data.id,
                Parent_ID: data.parent_ID,
                Title: data.title,
                dotic_ID: data.dotic_ID,
                CreateDate: data.createDate,
                Ordering: data.ordering,
                ExpireDate: data.expireDate,
                IsCategory: data.isCategory,
                State_ID: data.state_ID,
                isForign: data.isForign,
                Domain: data.domain,
                IsExecutor: data.isExecutor,
                PrevOrg_ID: data.prevOrg_ID,
                NextOrg_ID: data.nextOrg_ID,
                Comment: data.comment,
                User_ID: data.user_ID,
                inActive: data.inActive,
                Report_ID: data.report_ID,
                TopLaws: data.topLaws,
                TopTopic: data.topTopic,
                Header: data.header,
                Icon: data.icon,
              });

              if (data.parent_ID !== null) {
                const fetchChapterText = () => {
                  try {
                    // console.log('info.node.key', info.node.key);
                    fetch(
                      `${process.env.REACT_APP_BASE_URL}/api/Organization/ChapterText?id=${data.parent_ID}`,
                      {
                        method: 'Get',
                      },
                    ).then((res) => {
                      // console.log('res', res);
                      if (!res.ok) {
                        throw new Error(
                          'کد وضعیت خطا در درخواست!' + res.status,
                        );
                      }
                      return res
                        .json()
                        .then((data) => {
                          // console.log('data', data);
                          setExecutivSectionText(data);
                        })
                        .catch((error) => {
                          console.log('error', error);
                        });
                    });
                  } catch (error) {
                    console.log('error', error);
                  }
                };
                fetchChapterText();
              } else {
                setExecutivSectionText([]);
              }
            });
          })
          .catch((error) => {
            console.log('error', error);
          });
        // });
      } catch (error) {
        console.log('error', error);
      }
    };

    upsertSubFun();

    // let hero = document.getElementById(selectedKeys[0]);
    //e.preventDefault();  // Stop Page Reloading
    // hero && hero.scrollIntoView();
  };

  return (
    <Tree
      ref={treeRef}
      className="myCls"
      defaultExpandAll
      treeData={tdata ? tdata : ''}
      onSelect={onSelect}
      height={'auto'}
    />
  );
};

export default T2tree;
